module.exports = __webpack_public_path__ + "img/improvement.c4e9e4f5.jpg";